import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'ha/i18n';

import { PaymentOverviewButton as BasePaymentOverviewButton } from 'ha/components/PaymentOverviewButton/PaymentOverviewButton';

import {
  getListingEntity,
  getRentalConditions,
  getTenantFeeRuleName,
} from '../reducer';

export const PaymentOverviewButton: React.FC<{
  startDate: string;
  text?: string;
  type?: 'secondaryDark' | 'default';
}> = ({ startDate, text, type }) => {
  const { T } = useIntl();

  const listing = useSelector(getListingEntity);
  const rentalConditions = useSelector(getRentalConditions);
  const tenantFeeRuleName = useSelector(getTenantFeeRuleName);

  return (
    <BasePaymentOverviewButton
      dataTestLocator="ListingRentalConditionsSection/PaymentOverviewButton"
      listing={listing}
      rentalConditions={rentalConditions}
      startDate={startDate}
      tenantFeeRuleName={tenantFeeRuleName}
      text={text || T('StructuredCosts.LDP.cta_fullpaymentoverview')}
      type={type}
    />
  );
};
